var map = {
	"./caijiayiyi.svg": "4tTk",
	"./caipin.svg": "CvvZ",
	"./canshu.svg": "xWF3",
	"./comment.svg": "SdtW",
	"./data.svg": "RUrO",
	"./dingshirenwu.svg": "vq9E",
	"./dishes-data.svg": "04g/",
	"./example.svg": "OOLB",
	"./eye.svg": "4wdf",
	"./form.svg": "sTIr",
	"./gongshi.svg": "5rMo",
	"./gongyingshang.svg": "X5hz",
	"./home.svg": "U9Ws",
	"./list.svg": "vuHp",
	"./login-mall.svg": "xzZT",
	"./marker.svg": "0+/s",
	"./member.svg": "/LrJ",
	"./message.svg": "G2zY",
	"./order-data.svg": "kFQP",
	"./order-return-reason.svg": "PeRC",
	"./order-return.svg": "vigK",
	"./order-setting.svg": "LpN3",
	"./order.svg": "gYtG",
	"./orderManage.svg": "CBoU",
	"./paiban.svg": "6jv6",
	"./partner.svg": "EwS/",
	"./password.svg": "QjmH",
	"./peisongshijian.svg": "ByUf",
	"./pinlei.svg": "nYK3",
	"./powerBank.svg": "J+Wm",
	"./price-data.svg": "oy2r",
	"./product-add.svg": "Cuqr",
	"./product-attr.svg": "Aain",
	"./product-brand.svg": "JTBo",
	"./product-cate.svg": "G6Qz",
	"./product-comment.svg": "b5pz",
	"./product-list.svg": "qzoa",
	"./product-recycle.svg": "WSWy",
	"./product.svg": "UHi4",
	"./renwurizhi.svg": "/mb8",
	"./send-data.svg": "fpp9",
	"./shitang.svg": "0SL5",
	"./site.svg": "Bd3Y",
	"./sms-ad.svg": "2epx",
	"./sms-coupon.svg": "0Kk2",
	"./sms-flash.svg": "/KjT",
	"./sms-hot.svg": "If2y",
	"./sms-new.svg": "vvoC",
	"./sms-subject.svg": "4H1Q",
	"./sms.svg": "AS+9",
	"./staff.svg": "yyF4",
	"./system.svg": "Jax1",
	"./table.svg": "oSYw",
	"./total-today.svg": "le/7",
	"./total-week.svg": "csmh",
	"./total-yesterday.svg": "C15R",
	"./tree.svg": "3eCm",
	"./ums-admin.svg": "FR/6",
	"./ums-menu.svg": "sr5k",
	"./ums-resource.svg": "noU8",
	"./ums-role.svg": "w7oB",
	"./ums.svg": "J4x9",
	"./userManage.svg": "3MHU",
	"./vehicle.svg": "fQRN",
	"./withdrawal.svg": "+4WA",
	"./xitongcanshu.svg": "Avy7",
	"./xitongrizhi.svg": "wFJ5",
	"./zhibanzhanghao.svg": "a/iI",
	"./zidian.svg": "IBJT"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 45